<template>
  <div>
    <TipBox :title="$t('warning')" danger>
      {{$t('catering.preparation.warning_on_type')}}
    </TipBox>
    <Panel class="configurations" :title="$t('parameters')">
      <div class="columns">
        <div class="column">
          <div class="group">
            <label>{{$t('start')}}</label>
            <datetime
              v-model="parameters.start"
              value-zone="local"
              :use12-hour="hourFormat == '12'"
              input-id="p_start"
              :input-class="{invalid: $validate.error('parameters.start')}"
              input-style="width: 100%"
            />
          </div>
          <div class="group">
            <label>{{$t('end')}}</label>
            <datetime
              v-model="parameters.end"
              value-zone="local"
              :use12-hour="hourFormat == '12'"
              input-id="p_end"
              :input-class="{invalid: $validate.error('parameters.end')}"
              input-style="width: 100%"
            />
          </div>
        </div>
        <div class="column">
        </div>
      </div>
      <button class="btn btn-primary" @click="generate">{{$t('generate')}}</button>
    </Panel>

    <Panel :title="$t('catering.preparation.report')">
      <RawTable v-if="tableData" :columns="tableData.columns" :rows="tableData.rows" :keyValueHeader="queryOptions"/>
      <div v-else>{{$t('when_no_report')}}</div>
    </Panel>

    <Modal
      name="confirmation"
      :title="$t('catering.preparation.sale_status_in_preparation_confirmation').replace('%NB%', includedSaleIds ? includedSaleIds.length : 0)"
      :actions="[
        {name: $t('no'), action: 'close'},
        {name: $t('yes'), action: setIncludedSaleToPreparation, primary: true}
      ]"
    />

  </div>
</template>

<script>
  import RawTable from '@/components/RawTable.vue';
  import { mapActions } from "vuex";
  import moment from "moment-timezone";

  export default {
    name: "CateringPrep",

    components: { RawTable },

    data() {
      return {
        parameters: {
          start: moment().toISOString(),
          end: moment().toISOString()
        },
        queryOptions: null,
        tableData: null
      }
    },

    computed: {
      branchId() {
        return this.$route.query.branch;
      },
      companyId() {
        return this.$route.query.company;
      },
      includedSaleIds() {
        return this.tableData && this.tableData.moreData
          ? this.tableData.moreData.map(r => r.id)
          : null
      },
      hourFormat() {
        if (this.$store.state.contextCompany) {
          return this.$store.state.contextCompany.hourFormat;
        }
        return "24";
      },
    },

    created: function () {
      window.addEventListener('afterprint', this.onPrint);
    },

    destroyed: function () {
      window.removeEventListener('afterprint', this.onPrint);
    },

    validate: {
      "parameters.start": {
        required: true
      },
      "parameters.end": {
        required: true
      }
    },

    methods: {
      ...mapActions(["reportCateringPrep", "massSaveSale"]),

      async onPrint() {
        if (this.includedSaleIds) {
          this.$modal.show('confirmation', true)
        }
      },

      async setIncludedSaleToPreparation() {
        this.$modal.show('confirmation', false);
        if (!this.includedSaleIds) {
          return
        }
        let data = this.includedSaleIds.map(e => ({id: e, processingStatus: 'in_preparation'}));
        let response = await this.massSaveSale({data});
        if (response) {
          toast(this.$t('catering.preparation.sale_status_in_preparation_success').replace('%NB%', this.includedSaleIds.length), 'success')
        } else {
          toast(this.$t('error.no_server'), 'error');
        }
      },

      async generate() {
        if (!this.$validate.valid()) {
          this.$validate.validateAllOnce();
          return;
        }
        let options = {
          branch: this.branchId,
          company: this.companyId,
          start: this.parameters.start,
          end: this.parameters.end.replace('00:00:00', '23:59:59')
        };
        let response = await this.reportCateringPrep({options});
        if (response) {
          this.tableData = response.data;
          this.queryOptions = response.query;
        } else {
          toast(this.$t('error.no_server'), 'error');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .warning {
    color: indianred;
    font-weight: bold;
  }
  @media print {
    .configurations {
      display: none !important;
    }
  }
</style>
